import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    nickName: '',
    searchParams: {
      key: null,
      bigCateIds: [],
      areaIds: [],
      techniqueDictValues: [],
      efficacyDictValues: [],
      mealsGroupDictValues: [],
      crowdDictValues: [],
      halalFlag: null,
      meatVegetables: null,
      colorDictValues: [],
      seasonDictValues:[]
    },
    ingredientsParams: {
      key: null,
      halalFlag: null,
      edible: "1",
      areaIds: [],
      bigCateIds: [],
      crowdDictValues: [],
      efficacyDictValues: [],
      mealsGroupDictValues: [],
      nutrients: [],
      seasonDictValues: []
    },
    article: {
      pageNumber: 1,
      pageSize: 10,
      content: null,
      bigDictValue: null,
      smallDictValue: null
    },
    advise: {
      pageNumber: 1,
      pageSize: 10,
      content: null,
      bigDictValue: null,
      smallDictValue: null
    }
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_NICKNAME: (state, nickName) => {
      state.nickName = nickName;
    },
    SET_SEARCHPARAMS: (state,searchParams) => {
      state.searchParams = searchParams
    },
    SET_INGREDIENTS_SEARCHPARAMS: (state,ingredientsParams) => {
      state.ingredientsParams = ingredientsParams
    },
    SET_ARTICLE_SEARCHPARAMS: (state, articlesParams) => {
      state.article = articlesParams
    },
    SET_ADVISE_SEARCHPARAMS: (state, adviseParams) => {
      state.advise = adviseParams
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead+data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          commit('SET_NICKNAME', data.nickName)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
    setSearchParams({commit},query) {
      commit('SET_SEARCHPARAMS',query)
    },
    setIngredientsParams({commit},query) {
      commit('SET_INGREDIENTS_SEARCHPARAMS',query)
    },
    setArticleParams({commit},query) {
      commit('SET_ARTICLE_SEARCHPARAMS',query)
    },
    setAdviseParams({commit},query) {
      commit('SET_ADVISE_SEARCHPARAMS',query)
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js